import { render, staticRenderFns } from "./MyCompanyTablesNew.vue?vue&type=template&id=28b4a49a&scoped=true&"
import script from "./MyCompanyTablesNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyTablesNew.vue?vue&type=script&lang=js&"
import style0 from "./MyCompanyTablesNew.vue?vue&type=style&index=0&id=28b4a49a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b4a49a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
